import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const PasswordResetListComponent = React.lazy(() => import('./components/PasswordResetList'));

const SignUpCodeList = () => {
  const { pathname } = useLocation();

  return (
    <>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <PasswordResetListComponent />
      </Suspense>
    </>
  );
};

export default SignUpCodeList;
